import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TFeatureFlag } from "../types";

type FlagListParams = { page?: number; limit?: number; is_enabled?: string };
type FlagCallbacks = { onSuccess?: (res: any) => void; onError?: (err: any) => void };

export const useFeatureFlagList = (qData: FlagListParams = { limit: 100 }) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.FEATURE_FLAG, qData],
    queryFn: () => client.get(API_ENDPOINTS.FEATURE_FLAG, { params: qData }),
    select: (res: any) => res.data.data as TFeatureFlag[],
    refetchOnWindowFocus: false,
  });
};

export const useFeatureFlagSave = ({ onSuccess, onError }: FlagCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      data.id
        ? client.put(API_ENDPOINTS.FEATURE_FLAG + data.id, data)
        : client.post(API_ENDPOINTS.FEATURE_FLAG, data),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.FEATURE_FLAG] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};

export const useFeatureFlagToggle = ({ onSuccess, onError }: FlagCallbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.post(API_ENDPOINTS.FEATURE_FLAG_TOGGLE(id), {}),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.FEATURE_FLAG] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};

export const useFeatureFlagDelete = ({ onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.delete(API_ENDPOINTS.FEATURE_FLAG + id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.FEATURE_FLAG] });
      onSuccess?.();
    },
    onError: () => onError?.(),
  });
};
